import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './plugins/base'
import axios from 'axios'
import ServerError from './components/commonComponents/500'

import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)
Vue.component('ServerError', ServerError)

Window.axios = require('axios');

Vue.config.productionTip = false
Vue.prototype.baseURL = "http://13.126.53.44/file/get/";
axios.defaults.baseURL = "http://13.126.53.44";

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')